import React, { useState, useRef } from 'react';
import Icon from '@ant-design/icons';
import Slider from "react-slick";
import "../css/slick-carousel/slick.css";
import "../css/slick-carousel/slick-theme.css";
import { Col, Row, Flex, Button } from 'antd';
import { useQuery } from "@apollo/client";
import { leftSVG, rightSVG } from '../media/icons';
import {  
  GET_CAROUSELL_BY_SLUG, 
  GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG, 
  GET_THREE_COLUMNS_CARDS,
  GET_POST_LIST
} from "../queries";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import parsePosts from '../utils/parsePosts'
import useIsMobile from '../utils/isMobile'
import { 
  News, 
  SmallCard, 
  ImageOverlay, 
  LargeCard 
} from './Cards';
import parseCarousellData from '../utils/parseCarousellData';
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"

const LeftIcon = (props) => <Icon component={leftSVG} {...props} />;
const RightIcon = (props) => <Icon component={rightSVG} {...props} />;

const mediaDir = (lang) => {
	let dir = ''
	
	if (lang === 'es') {
		dir = 'medios'
	} else if (lang === 'en') {
		dir = 'media'
	} else if (lang === 'pt') {
		dir = 'midia'
	}
	
	return dir
}

const CarouselComp = ({ page, section, type, buttons = true, lang, numPosts, categoryName }) => {
  const slug = `${page}-${section}-${lang}`; 
  const isMobile = useIsMobile();
  const slider = useRef(null);
  const [queryType, setQueryType] = useState(() => {
    return (section.includes('-')) ? section.split("-")[0] : section
  })
  const [sectionData, setSectionData] = useState(() => { 
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null; 
  }); 
  
  
  const renderQuery = () => { 
    const contentMap = { 
      postlist: GET_POST_LIST, 
      fourcolumnsrounded: GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG,
      threecolumnscards: GET_THREE_COLUMNS_CARDS,
      carousell: GET_CAROUSELL_BY_SLUG,
    };   
    return contentMap[queryType] || GET_CAROUSELL_BY_SLUG; 
  };
    
  const { loading, error } = useQuery(renderQuery(), { 
    variables: { slug, numPosts, categoryName, lang: lang === 'pt' ? 'pt-br' : lang }, 
    skip: !!sectionData, 
    onCompleted: (fetchedData) => {      
      let postData     
      if (type === 'posts') {
        postData = {
          titulo: fetchedData.sectionsBy?.postlist?.tituloPl,
          posts: parsePosts(fetchedData?.posts),
        }
      } else {
        postData = {
          titulo: fetchedData.sectionsBy?.[queryType]?.titulo ? 
            fetchedData.sectionsBy?.[queryType]?.titulo : 
            fetchedData.sectionsBy?.[queryType]?.tituloFcr ? 
              fetchedData.sectionsBy?.[queryType]?.tituloFcr :
              fetchedData.sectionsBy?.[queryType]?.tituloCarousell,
          images: fetchedData.sectionsBy?.[queryType]?.images 
            ? parseCarousellData(fetchedData.sectionsBy?.[queryType]?.images)
            : []

        }

        if (fetchedData.sectionsBy?.[queryType]?.link)
          postData.link = fetchedData.sectionsBy?.[queryType]?.link

      }
      const dataToLocal = {
        ...sectionData, 
        sections: { 
          [slug]: postData, 
        }, 
      }; 
      saveToLocalStorage(page, dataToLocal); 
      setSectionData(postData);
    }, 
  });
  
  const titulo = sectionData?.titulo || '';
  const content = type === 'posts' 
    ? sectionData?.posts
    : sectionData?.images;
  
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
    {
      sectionData && (
        <Flex vertical>
          <Flex className='CarouselComp-title'>
            <h2
              className="h4-headline-500"
              dangerouslySetInnerHTML={{ __html: titulo }}
            />
            {sectionData?.link && (
              <Button 
                className="bt-medium-500" 
                style={{color: '#0027F9' }} 
                type="link" 
                href={sectionData?.link?.url || '#'} 
                variant="link">
                  {sectionData?.link?.title || 'Get Started'}
              </Button>
            )}
            {buttons && (
              <div>
                <LeftIcon style={{
                  background: '#F9F9F9',
                  borderRadius: '24px',
                  fontSize: '32px',
                  marginRight: '5px'
                }} onClick={() => slider?.current?.slickPrev()} />
                <RightIcon style={{
                  background: '#F9F9F9',
                  borderRadius: '24px',
                  fontSize: '32px',
                }} onClick={() => slider?.current?.slickNext()}/>
              </div>
            )}
          </Flex>
          <Row>
            <Col span={24}>
              <div className="slider-container">
                <Slider ref={slider} {...settings}>
                  {content?.map((item, index) => {
                    if (item) {
                      if (type === 'posts') {
                        return (
                          <News key={index} title={item.title} image={setImageAbsoluteUrl(item.mediaItemUrl)} description={item.content} slug={`/${lang}/${categoryName}/${item.slug}`} isMobile={isMobile} lang={lang}/>
                        )
                      } else if (type === 'smallCards') {
                        return (
                          <SmallCard key={index} title={item.title} image={setImageAbsoluteUrl(item.mediaItemUrl)} description={item.content} isMobile={isMobile}/>
                        )
                      } else if (type === 'imageOverlay') {
                        return (
                          <ImageOverlay key={index} description={item.content} mediaItemUrl={setImageAbsoluteUrl(item.mediaItemUrl)} altText={item.title}/>
                        )
                      } else if (type === 'largeCards') {
                        return (
                          <LargeCard key={index} title={item.title} description={item.content} mediaItemUrl={setImageAbsoluteUrl(item.mediaItemUrl)} altText={item.imageName}/>
                        )
                      }
                    }
                  })}
                </Slider>
              </div>
            </Col>
          </Row>
        </Flex>
      )
    }
    </>
  );
}

export default CarouselComp;
